import { InjectionToken } from '@angular/core';

/**
 * Optional route after password-reset / activation when terms & conditions were accepted
 * (e.g. ING-BE company details). When provided, Continue navigates here after login
 * instead of going straight into the app.
 *
 * The string passed to `InjectionToken` is only a debug description (shown in DI errors);
 * Angular matches the token by object identity, not by that string.
 */
export const CUSTOM_PAGE_AFTER_ACCEPTING_TERMS_AND_CONDITIONS = new InjectionToken<string>(
  'Custom page after accepting terms and conditions'
);
